import { Skeleton } from "@mui/material";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React from "react";

const TableRowSkeleton = ({
  rowsNum,
  columnsNum,
  height = 30,
  width = 100,
}: {
  rowsNum: number;
  columnsNum?: number;
  height?: number;
  width?: number;
}) => {
  return (
    <>
      <>
        {[...Array(rowsNum)].map(() => (
          <TableRow>
            {[...Array(columnsNum)].map(() => (
              <>
                <TableCell sx={{ textAlign: "center" }}>
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={height}
                    sx={{ borderRadus: "5px" }}
                    width={width}
                  />
                </TableCell>
              </>
            ))}
          </TableRow>
        ))}
      </>
    </>
  );
};

export default TableRowSkeleton;
